const PROTOCOL = process.env.NEXT_PUBLIC_PROTOCOL
const DOMAIN = process.env.NEXT_PUBLIC_DOMAIN

const salonLink = (subdomain) => {
    return subdomain
        ? `${PROTOCOL}://${subdomain}.${DOMAIN}`
        : '/'
}

export default salonLink